import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=83d59766&scoped=true&"
import script from "./Media.vue?vue&type=script&lang=ts&"
export * from "./Media.vue?vue&type=script&lang=ts&"
import style0 from "./Media.vue?vue&type=style&index=0&id=83d59766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d59766",
  null
  
)

export default component.exports